import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No',  label: 'No'  },
];

// When Yes: DeadboltHole and PassagePrep become visible
const MultipointPrep = ({ value = { value: '', label: '' }, onChange, disabled = false, onChildrenVisible }) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
    onChildrenVisible?.(v === 'No');
  };

  return (
    <div className="a-container">
      <label htmlFor="SdMultipointPrep">Multipoint Prep</label>
      <select id="SdMultipointPrep" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MultipointPrep;
